export default __webpack_public_path__ + "static/media/step2.66a19877.png";